import { render, staticRenderFns } from "./PreOldStudent.vue?vue&type=template&id=565eea17&scoped=true&"
import script from "./PreOldStudent.vue?vue&type=script&lang=js&"
export * from "./PreOldStudent.vue?vue&type=script&lang=js&"
import style0 from "./PreOldStudent.vue?vue&type=style&index=0&id=565eea17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565eea17",
  null
  
)

export default component.exports